import { render, staticRenderFns } from "./communityManagement.vue?vue&type=template&id=57dc36d3&scoped=true&"
import script from "./communityManagement.vue?vue&type=script&lang=js&"
export * from "./communityManagement.vue?vue&type=script&lang=js&"
import style0 from "./communityManagement.vue?vue&type=style&index=0&id=57dc36d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dc36d3",
  null
  
)

export default component.exports